export default __webpack_public_path__ + "static/media/img_henshin_bike.45cb5aa9.png";